import React from 'react';

import styles from './ApplicationsPage.module.css';

type Props = {
  children: React.ReactNode;
};

export const ApplicationsPageWrapper: React.FC<Props> = ({ children }) => (
  <div className={styles.ApplicationsPage__Wrapper}>{children}</div>
);
